import Vue from "vue";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";

/**
 * @method apiRequestOTP
 * @method apiLogin
 * @method apiLogout
 * @method apiLoginLine
 * @method apiLoginDevice
 * @method apiReLoginDevice
 * @method apiRegister
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },
    /**
     * @param {String} contactNumber (required)
     * @param {String|Null} uuid (optional)
     */
    apiGetMId: function(lineToken) {
        var params = {
            appId: this.config().client_id,
            id_token: lineToken
        };
        const url = ConfigManager.getApiModuleUrl() + "/sso/check";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => res.data)
        );
    },
    /**
     * @param {String} app_id (required)
     * @param {String|Null} uuid (optional)
     */
    apiRequestOTP: function(contactNumber, uuid, channel) {
        var params = {
            contact_number: contactNumber,
            app_id: this.config().client_id,
            uuid: uuid,
            channel: channel
        };
        const url = ConfigManager.getApiUrl() + "/auth/otp";
        return BzbsApi.connectBzbsGet(url, null, params);
    },
    /**
     * @param {String} token
     * @param {String} idCardNo
     * @param {String} contactNumber
     * @param {String} refcode
     * @param {String|Number} otp
     * @param {String|Number} termAndCondition
     */
    confirmOtp: function(token, idCardNo, contactNumber, refcode, otp) {
        var params = {
            id_token: token,
            id_CardNo: idCardNo,
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
            termAndCondition: 0
        };

        var url = this.config().bzbsUrl + "/auth/bzbs_authen";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => res.data)
        );
    },
    /**
     * @param {String} username
     * @param {String} password
     * @param {String} strUUID
     * @param {String} strDeviceToken
     * @param {String} strClientVersion
     * @param {Boolean} isDeviceNotiEnable
     */
    apiLogin: function(
        username,
        password,
        strUUID,
        strDeviceToken,
        strClientVersion,
        isDeviceNotiEnable
    ) {
        const params = {
            username: username,
            password: password,
            uuid: strUUID,
            app_id: ConfigManager.getAppId(),
            os: "web",
            platform: "web",
            mac_address: strUUID,
            device_noti_enable: isDeviceNotiEnable,
            client_version: strClientVersion,
            device_token: strDeviceToken
        };

        const url = ConfigManager.getApiUrl() + "/auth/bzbs_login";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    /**
     * @param {Boolean} keepData
     * @param {String} strBzbsToken
     */
    apiDeactive: function(strBzbsToken, keepData) {
        var params = {
            keepData: keepData
        };
        const url = ConfigManager.getApiModuleUrl() + "/sso/deactive";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params).pipe(
            map(res => res.data)
        );
    },
    /**
     * @param {Boolean} keepData
     * @param {String} strBzbsToken
     */
    apiDeactiveSingle: function(strBzbsToken, keepData) {
        var params = {
            keepData: keepData
        };
        const url = ConfigManager.getApiModuleUrl() + "/sso/deactive_single";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params).pipe(
            map(res => res.data)
        );
    },
    /**
     * @param {Boolean} contactNumber
     * @param {String} strBzbsToken
     */
    apiVerifyResume: function(strBzbsToken, contactNumber) {
        var params = {
            appId: ConfigManager.getAppId(),
            id_token: strBzbsToken,
            contactNumber: contactNumber
        };
        const url = ConfigManager.getApiModuleUrl() + "/sso/verifyresume";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => res.data)
        );
    },
    /**
     * @param {Boolean} contactNumber
     * @param {String} strBzbsToken
     */
    apiResume: function(strBzbsToken, contactNumber, otp, refcode) {
        var params = {
            appId: ConfigManager.getAppId(),
            id_token: strBzbsToken,
            contactNumber: contactNumber,
            otp: otp,
            refcode: refcode
        };
        const url = ConfigManager.getApiModuleUrl() + "/sso/resume_single";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => res.data)
        );
    },
    /**
     * @param {String} strBzbsToken
     * @param {String} strFBToken
     * @param {String} strUUID
     */
    apiLogout: function(strBzbsToken, strFBToken, strUUID) {
        const params = {
            uuid: strUUID,
            access_token: strFBToken
        };

        const url = ConfigManager.getApiUrl() + "/auth/logout";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * @param {string} lineIdToken
     */
    apiLoginLine: function(lineIdToken) {
        const params = {
            app_id: ConfigManager.getAppId(),
            id_token: lineIdToken
        };

        const url = ConfigManager.getApiUrl() + "/auth/line_login";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    apiLoginLineService: function(lineIdToken) {
        const params = {
            app_id: ConfigManager.getAppId(),
            id_token: lineIdToken
        };

        const url = ConfigManager.getApiUrl() + "/auth/line_login";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * @param {AuthDeviceLoginModel} params /core/Account/model/AuthConfigModel.js
     */
    apiLoginDevice: function(params) {
        params.app_id = ConfigManager.getAppId();

        const url = ConfigManager.getApiUrl() + "/auth/device_login";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Resume Login
     * @param {string } token
     * @param {Object} data  // cache user
     */
    apiReLoginDevice: function(token, uuid) {
        const params = {
            uuid: uuid,
            app_id: ConfigManager.getAppId(),
            os: "web",
            platform: "web",
            mac_address: uuid
            // device_noti_enable: data.isDeviceNotiEnable,
            // client_version: data.strClientVersion,
        };

        const url = ConfigManager.getApiUrl() + "/auth/device_resume";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    apiRegister(params) {
        const url = ConfigManager.getApiModuleUrl() + "/sso/register";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    getBlob() {
        const url = `/nestle/nestle_sso/custom/nestle_sso_content.json`;
        return new Promise((resolve, reject) => {
            BzbsCustom.apiGetCustom(url)
                .then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
};
